export const CustomCheckCircle = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <circle cx="12" cy="12" r="11" fill="white" stroke="#5A6EFA" strokeWidth="2" />
      <path
        d="M7 12.5L10 15.5L17 8.5"
        stroke="#5A6EFA"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const HotkeyBadge = ({ hotkey, className = "" }: { hotkey: string; className?: string }) => (
  <div
    className={`pointer-events-none absolute -left-2 -top-2 z-30 flex items-center justify-center rounded-[6px] border border-[#E2E8F0] bg-[#F8FAFC] px-1.5 py-0.5 text-[10px] font-extrabold uppercase tracking-widest text-[#64748b] shadow-sm ${className}`}
  >
    {hotkey}
  </div>
);
